
// Import JS Modules
import { builderDispatch, WebUI } from '../../_utils/ui';

const showLoginOverlay = (() => {
  let deferreds = [];

  builderDispatch.register((payload) => {
    switch (payload.type) {
      case WebUI.LOGIN:
        deferreds.forEach((deferred) => {
          deferred.resolve();
        });
        deferreds = [];
        break;
    }
  });

  return function () {
    const showLoginEvent = new Event('showLogin');
    window.dispatchEvent(showLoginEvent);

    const deferred = new Promise((resolve) => {
      deferreds.push({ resolve });
    });

    return deferred;
  };
})();

export default showLoginOverlay;
